import { render, staticRenderFns } from "./id-exam.vue?vue&type=template&id=1ff1b88c&scoped=true"
import script from "./id-exam.vue?vue&type=script&lang=ts"
export * from "./id-exam.vue?vue&type=script&lang=ts"
import style0 from "./id-exam.vue?vue&type=style&index=0&id=1ff1b88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff1b88c",
  null
  
)

export default component.exports